/**
 * Shared portal container ID for all floating elements.
 * Using a consistent ID ensures all tooltips/popovers share one container
 * with proper z-index above modals.
 */
export const FLOATING_PORTAL_ID = "floating-ui-portal-root";

/**
 * Injects the portal root styles once into the document head.
 * Call this early in app initialization (e.g., in your root component or main.tsx).
 */
let stylesInjected = false;

export function injectFloatingPortalStyles(): void {
  if (stylesInjected || typeof document === "undefined") return;

  const style = document.createElement("style");
  style.id = "floating-portal-styles";
  style.textContent = `
    #${FLOATING_PORTAL_ID} {
      position: relative;
      z-index: 99999;
    }
  `;
  document.head.appendChild(style);
  stylesInjected = true;
}
